module.exports = __webpack_public_path__ + "img/tecnologicagente.a71871be.jpg";